import { EPageActionTypes, TQueryParams } from '../../types/page/pageType';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export type TSetPageQueryParams = ITypedReduxAction<EPageActionTypes.SetPageQueryParams, TQueryParams>;

export const setQueryParams: (queryParams: TQueryParams) => TSetPageQueryParams = actionGenerator<
  EPageActionTypes.SetPageQueryParams,
  TQueryParams
>(EPageActionTypes.SetPageQueryParams);
